import React from "react";

// ASSETS
import RedTriangleIcon from "assets/svg/RedTriangleIcon.svg";
import WhiteTriangleIcon from "assets/svg/WhiteTriangleIcon.svg";
import RightRedIcon from "assets/svg/RightRedIcon.svg";
import RightWhiteIcon from "assets/svg/RightWhiteIcon.svg";
import XSign from "assets/svg/XSign.svg";

// STYLES
import { Button, Icon } from "./ButtonAtomStyled";

// LIBRARIES
import { useSelector } from "react-redux";

// MISC
import { TextType } from "../CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { ButtonAtomProps, ButtonType } from "./ButtonAtomModel";

// REDUX
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "../CustomText/CustomText";

const ButtonAtom = (props: ButtonAtomProps) => {
  // PROPERTIES
  const {
    text,
    leftIcon,
    rightIcon,
    arrowDown,
    type,
    onClick,
    disabled = false,
    icon,
    hasArrow,
  } = props;
  // LIBRARY CONSTANTS

  // STATE CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <Button
      type={type}
      onClick={onClick}
      biggerCursor={biggerCursor}
      disabled={disabled}
    >
      {type === ButtonType.X && <Icon src={XSign} alt="x" type={type} />}
      {type === ButtonType.ChatButton && icon && (
        <Icon src={icon} alt="x" type={type} />
      )}
      {leftIcon && (
        <Icon
          src={disabled ? WhiteTriangleIcon : RedTriangleIcon}
          alt="LeftIcon"
          type={type}
        />
      )}
      {type === ButtonType.Link ? (
        <CustomText text={text} type={TextType.H6} color={COLORS.RaisinBlack} />
      ) : (
        <CustomText
          text={text}
          type={TextType.H5}
          color={
            disabled ||
              type === ButtonType.MapActive ||
              type === ButtonType.RedButton ||
              type === ButtonType.RedButtonWhiteIcon ||
              type === ButtonType.CookieButton ||
              type === ButtonType.ManagementButton
              ? COLORS.Cultured
              : type === ButtonType.ArrowDown ||
                type === ButtonType.ArrowDownRed ||
                type === ButtonType.BlackButton
              ? COLORS.Cultured
              : COLORS.RaisinBlack
          }
        />
      )}
      {type === ButtonType.RedButton && hasArrow && (
        <Icon src={RightWhiteIcon} alt="RightIcon" type={type} />
      )}

      {rightIcon && !arrowDown && (
        <Icon
          src={
            type === ButtonType.RedButtonWhiteIcon
              ? RightWhiteIcon
              : RightRedIcon
          }
          alt="RightIcon"
          type={type}
        />
      )}
      {rightIcon && arrowDown && (
        <Icon
          src={
            type === ButtonType.ArrowDownDefault ? RightRedIcon : RightWhiteIcon
          }
          alt="RightIcon"
          type={type}
          arrowDown={arrowDown}
        />
      )}
    </Button>
  );
};

export default ButtonAtom;
